import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import PrintIcon from '@material-ui/icons/Print';
import { notify } from '../../../redux/utils/notifications/notifications';
import { convertToDateString } from '../../../redux/utils/customMethods';
import { useStyles, StyledTableCell } from './timesheetStyles';
import TimeInputRow from './TimeInputRow';
import ExportExcelUser from '../timesheet/exportExcel/ExportExcel';
import {
  Table,
  Button,
  TableBody,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Grid,
  MenuItem,
  FormControl,
  Select,
  FormControlLabel,
  Checkbox,
  SvgIcon,
  Chip,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TableContainer,
  Typography,
} from '@material-ui/core';
import {
  UPLOAD_FILE_SIZE,
  DB_DATE_FORMAT,
  DISPLAY_DATE_FORMAT,
} from '../../../redux/constants';
// import { CHAT_KEY } from './../../../keys';
import {
  fetchTimesheet,
  updateTimesheet,
  removeAttachment,
  uploadTimeSheetAttachments,
} from '../../../redux/timesheets/timesheetsActions';
import logoUrl from '../../../assets/SciataLogoDark.png';
const employeeDetailColumns = [
  { id: 'date', label: 'Date', minWidth: 200, align: 'center' },
  { id: 'hours', label: 'Hours', minWidth: 200, align: 'center' },
  { id: 'task', label: 'Task', minWidth: 100, align: 'center' },
  { id: 'status', label: 'Status', minWidth: 100, align: 'center' },
  { id: 'note', label: 'Note', minWidth: 200, align: 'center' },
];

const Timesheet = props => {
  document.title = 'Sciata Timesheet';

  const classes = useStyles();
  const dispatch = useDispatch();
  const timesheet = useSelector(state => state.timesheets.currentTimesheet);
  const attachments = useSelector(state => state.timesheets.attachments);
  const user = useSelector(state => state.users.currentUser);
  const projects = user.projects;
  const defaultProject = projects.filter(project => project.isDefault)[0];

  const [regularStatus, setRegularStatus] = useState('billable');
  const [holidayStatus, setHolidayStatus] = useState('non-billable');
  const [bereavementStatus, setBereavementStatus] = useState('non-billable');
  const [vacationStatus, setVacationStatus] = useState('non-billable');
  const [sickStatus, setSickStatus] = useState('non-billable');
  const [comments, setComments] = useState('');
  const [weekDays, setWeekDays] = useState([]);
  const [arrowClick, setArrowClick] = useState(0);
  const [project, setProject] = useState(defaultProject);
  const [projectRows, setProjectRows] = useState([]);
  const [chatOpen, setChatOpen] = useState(false);
  const [week, setWeek] = useState({
    startDate: moment(moment().startOf('week')).format(DB_DATE_FORMAT),
    endDate: moment(moment().endOf('week')).format(DB_DATE_FORMAT),
  });
  const [projectValues, setProjectValues] = useState({
    [defaultProject.name]: {
      monday: '',
      tuesday: '',
      wednesday: '',
      thursday: '',
      friday: '',
      saturday: '',
      sunday: '',
    },
  });
  const [projectNotes, setProjectNotes] = useState({
    [defaultProject.name]: {
      monday: '',
      tuesday: '',
      wednesday: '',
      thursday: '',
      friday: '',
      saturday: '',
      sunday: '',
    },
  });
  const [projectIds, setProjectIds] = useState({
    [defaultProject.name]: {
      monday: '',
      tuesday: '',
      wednesday: '',
      thursday: '',
      friday: '',
      saturday: '',
      sunday: '',
    },
  });
  const [openProjectNotes, setOpenProjectNotes] = useState({
    [defaultProject.name]: {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
    },
  });

  // const chatSrc = `https://webchat.botframework.com/embed/SciataBot?s=${CHAT_KEY}`;
  const CHAT_KEY = 'DEGwT8Xi8yY.wLSAYoBZ9G2z8j44dd3yqTn_2pEEEoNk3xKxdrH3J70';
  const chatSrc = `https://webchat.botframework.com/embed/SciataBot?s=${CHAT_KEY}`;
  // console.log('CHAT SRC', chatSrc);

  const handleChatClose = () => setChatOpen(false);

  const handleChatOpen = row => {
    setChatOpen(true);
  };

  const weeksObject = (defaultVal = '') => {
    return {
      monday: defaultVal,
      tuesday: defaultVal,
      wednesday: defaultVal,
      thursday: defaultVal,
      friday: defaultVal,
      saturday: defaultVal,
      sunday: defaultVal,
    };
  };

  const handleProject = e => {
    let selectedItem = e.target.value[e.target.value.length - 1];
    setProject({ name: selectedItem, code: e.target.name });
    setProjectRows(e.target.value);
    setFilteredItems({ ...filteredItems, [selectedItem]: true });
    setProjectValues({
      ...projectValues,
      [selectedItem]: {
        monday: '',
        tuesday: '',
        wednesday: '',
        thursday: '',
        friday: '',
        saturday: '',
        sunday: '',
      },
    });
    setProjectIds({
      ...projectIds,
      [selectedItem]: {
        monday: '',
        tuesday: '',
        wednesday: '',
        thursday: '',
        friday: '',
        saturday: '',
        sunday: '',
      },
    });
    setProjectNotes({
      ...projectNotes,
      [selectedItem]: {
        monday: '',
        tuesday: '',
        wednesday: '',
        thursday: '',
        friday: '',
        saturday: '',
        sunday: '',
      },
    });
    setOpenProjectNotes({
      ...openProjectNotes,
      [selectedItem]: {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
      },
    });
    handleClose();
  };

  const [render, setRender] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setRender(true);
    }, 500);
  }, []);

  const [renderAttachment, setRenderAttachment] = useState(false);

  useEffect(() => {
    let getDaysArray = (start, end) => {
      for (
        var arr = [], dt = new Date(start);
        dt <= new Date(end);
        dt.setDate(dt.getDate() + 1)
      ) {
        arr.push(new Date(dt));
      }
      return arr;
    };

    const daylist = getDaysArray(
      moment(`${week.startDate}`, DB_DATE_FORMAT),
      moment(`${week.endDate}`, DB_DATE_FORMAT)
    );

    const daysArr = daylist.map(day => moment(day, DB_DATE_FORMAT).format('MM-DD'));

    setWeekDays(daysArr);
  }, [week]);

  const [attachmentList, setAttachmentList] = useState([]);
  useEffect(() => {
    setAttachmentList(attachments);
  }, [attachments, renderAttachment]);

  const [holidayValuesMonday, setHolidayValuesMonday] = useState('');
  const [holidayValuesTuesday, setHolidayValuesTuesday] = useState('');
  const [holidayValuesWednesday, setHolidayValuesWednesday] = useState('');
  const [holidayValuesThursday, setHolidayValuesThursday] = useState('');
  const [holidayValuesFriday, setHolidayValuesFriday] = useState('');
  const [holidayValuesSaturday, setHolidayValuesSaturday] = useState('');
  const [holidayValuesSunday, setHolidayValuesSunday] = useState('');

  const [vacationValuesMonday, setVacationValuesMonday] = useState('');
  const [vacationValuesTuesday, setVacationValuesTuesday] = useState('');
  const [vacationValuesWednesday, setVacationValuesWednesday] = useState('');
  const [vacationValuesThursday, setVacationValuesThursday] = useState('');
  const [vacationValuesFriday, setVacationValuesFriday] = useState('');
  const [vacationValuesSaturday, setVacationValuesSaturday] = useState('');
  const [vacationValuesSunday, setVacationValuesSunday] = useState('');

  const [sickValuesMonday, setSickValuesMonday] = useState('');
  const [sickValuesTuesday, setSickValuesTuesday] = useState('');
  const [sickValuesWednesday, setSickValuesWednesday] = useState('');
  const [sickValuesThursday, setSickValuesThursday] = useState('');
  const [sickValuesFriday, setSickValuesFriday] = useState('');
  const [sickValuesSaturday, setSickValuesSaturday] = useState('');
  const [sickValuesSunday, setSickValuesSunday] = useState('');

  const [bereavementValuesMonday, setBereavementValuesMonday] = useState('');
  const [bereavementValuesTuesday, setBereavementValuesTuesday] = useState('');
  const [bereavementValuesWednesday, setBereavementValuesWednesday] = useState('');
  const [bereavementValuesThursday, setBereavementValuesThursday] = useState('');
  const [bereavementValuesFriday, setBereavementValuesFriday] = useState('');
  const [bereavementValuesSaturday, setBereavementValuesSaturday] = useState('');
  const [bereavementValuesSunday, setBereavementValuesSunday] = useState('');

  const [holidayNotesMonday, setHolidayNotesMonday] = useState('');
  const [holidayNotesTuesday, setHolidayNotesTuesday] = useState('');
  const [holidayNotesWednesday, setHolidayNotesWednesday] = useState('');
  const [holidayNotesThursday, setHolidayNotesThursday] = useState('');
  const [holidayNotesFriday, setHolidayNotesFriday] = useState('');
  const [holidayNotesSaturday, setHolidayNotesSaturday] = useState('');
  const [holidayNotesSunday, setHolidayNotesSunday] = useState('');

  const [bereavementNotesMonday, setBereavementNotesMonday] = useState('');
  const [bereavementNotesTuesday, setBereavementNotesTuesday] = useState('');
  const [bereavementNotesWednesday, setBereavementNotesWednesday] = useState('');
  const [bereavementNotesThursday, setBereavementNotesThursday] = useState('');
  const [bereavementNotesFriday, setBereavementNotesFriday] = useState('');
  const [bereavementNotesSaturday, setBereavementNotesSaturday] = useState('');
  const [bereavementNotesSunday, setBereavementNotesSunday] = useState('');

  const [vacationNotesMonday, setVacationNotesMonday] = useState('');
  const [vacationNotesTuesday, setVacationNotesTuesday] = useState('');
  const [vacationNotesWednesday, setVacationNotesWednesday] = useState('');
  const [vacationNotesThursday, setVacationNotesThursday] = useState('');
  const [vacationNotesFriday, setVacationNotesFriday] = useState('');
  const [vacationNotesSaturday, setVacationNotesSaturday] = useState('');
  const [vacationNotesSunday, setVacationNotesSunday] = useState('');

  const [sickNotesMonday, setSickNotesMonday] = useState('');
  const [sickNotesTuesday, setSickNotesTuesday] = useState('');
  const [sickNotesWednesday, setSickNotesWednesday] = useState('');
  const [sickNotesThursday, setSickNotesThursday] = useState('');
  const [sickNotesFriday, setSickNotesFriday] = useState('');
  const [sickNotesSaturday, setSickNotesSaturday] = useState('');
  const [sickNotesSunday, setSickNotesSunday] = useState('');
  const [openFilters, setOpenFilters] = useState(false);
  const [filteredItems, setFilteredItems] = useState({
    Vacation: true,
    Holiday: true,
    Sick: true,
    [defaultProject.name]: true,
  });

  useEffect(() => {
    if (!Object.keys(filteredItems).includes(project.name)) {
      setFilteredItems({ ...filteredItems, [project.name]: true });
    }
  }, [project]);

  const [monHolId, setMonHolId] = React.useState(null);
  const [tueHolId, setTueHolId] = React.useState(null);
  const [wedHolId, setWedHolId] = React.useState(null);
  const [thuHolId, setThuHolId] = React.useState(null);
  const [friHolId, setFriHolId] = React.useState(null);
  const [satHolId, setSatHolId] = React.useState(null);
  const [sunHolId, setSunHolId] = React.useState(null);

  const [monBerId, setMonBreId] = React.useState(null);
  const [tueBerId, setTueBreId] = React.useState(null);
  const [wedBerId, setWedBreId] = React.useState(null);
  const [thuBerId, setThuBreId] = React.useState(null);
  const [friBerId, setFriBreId] = React.useState(null);
  const [satBerId, setSatBreId] = React.useState(null);
  const [sunBerId, setSunBreId] = React.useState(null);

  const [monVacId, setMonVacId] = React.useState(null);
  const [tueVacId, setTueVacId] = React.useState(null);
  const [wedVacId, setWedVacId] = React.useState(null);
  const [thuVacId, setThuVacId] = React.useState(null);
  const [friVacId, setFriVacId] = React.useState(null);
  const [satVacId, setSatVacId] = React.useState(null);
  const [sunVacId, setSunVacId] = React.useState(null);

  const [monSickId, setMonSickId] = React.useState(null);
  const [tueSickId, setTueSickId] = React.useState(null);
  const [wedSickId, setWedSickId] = React.useState(null);
  const [thuSickId, setThuSickId] = React.useState(null);
  const [friSickId, setFriSickId] = React.useState(null);
  const [satSickId, setSatSickId] = React.useState(null);
  const [sunSickId, setSunSickId] = React.useState(null);

  const [openMonHol, setOpenMonHol] = React.useState(false);
  const [openTueHol, setOpenTueHol] = React.useState(false);
  const [openWedHol, setOpenWedHol] = React.useState(false);
  const [openThuHol, setOpenThuHol] = React.useState(false);
  const [openFriHol, setOpenFriHol] = React.useState(false);
  const [openSatHol, setOpenSatHol] = React.useState(false);
  const [openSunHol, setOpenSunHol] = React.useState(false);

  const [openMonVac, setOpenMonVac] = React.useState(false);
  const [openTueVac, setOpenTueVac] = React.useState(false);
  const [openWedVac, setOpenWedVac] = React.useState(false);
  const [openThuVac, setOpenThuVac] = React.useState(false);
  const [openFriVac, setOpenFriVac] = React.useState(false);
  const [openSatVac, setOpenSatVac] = React.useState(false);
  const [openSunVac, setOpenSunVac] = React.useState(false);

  const [openMonSick, setOpenMonSick] = React.useState(false);
  const [openTueSick, setOpenTueSick] = React.useState(false);
  const [openWedSick, setOpenWedSick] = React.useState(false);
  const [openThuSick, setOpenThuSick] = React.useState(false);
  const [openFriSick, setOpenFriSick] = React.useState(false);
  const [openSatSick, setOpenSatSick] = React.useState(false);
  const [openSunSick, setOpenSunSick] = React.useState(false);

  const [openMonBere, setOpenMonBere] = React.useState(false);
  const [openTueBere, setOpenTueBere] = React.useState(false);
  const [openWedBere, setOpenWedBere] = React.useState(false);
  const [openThuBere, setOpenThuBere] = React.useState(false);
  const [openFriBere, setOpenFriBere] = React.useState(false);
  const [openSatBere, setOpenSatBere] = React.useState(false);
  const [openSunBere, setOpenSunBere] = React.useState(false);

  const [disable, setDisable] = useState(false);

  useEffect(() => {
    setDisable(false);
    if (timesheet && timesheet.weekly && timesheet.weekly[0]) {
      if (timesheet.weekly[0].status === 'APPROVED') {
        setDisable(true);
      }
    }
  }, [timesheet]);

  const [disableButtons, setDisableButtons] = useState(false);
  useEffect(() => {
    setDisableButtons(true);

    let isProjectValues = false;
    for (let project in projectValues) {
      let proj = projectValues[project];
      for (let day in proj) {
        if (proj[day] !== '') {
          isProjectValues = true;
        }
      }
    }

    if (isProjectValues) {
      setDisableButtons(false);
    }
    if (
      holidayValuesMonday !== '' ||
      holidayValuesTuesday !== '' ||
      holidayValuesWednesday !== '' ||
      holidayValuesThursday !== '' ||
      holidayValuesFriday !== '' ||
      holidayValuesSaturday !== '' ||
      holidayValuesSunday !== '' ||
      vacationValuesMonday !== '' ||
      vacationValuesTuesday !== '' ||
      vacationValuesWednesday !== '' ||
      vacationValuesThursday !== '' ||
      vacationValuesFriday !== '' ||
      vacationValuesSaturday !== '' ||
      vacationValuesSunday !== '' ||
      sickValuesMonday !== '' ||
      sickValuesTuesday !== '' ||
      sickValuesWednesday !== '' ||
      sickValuesThursday !== '' ||
      sickValuesFriday !== '' ||
      sickValuesSaturday !== '' ||
      sickValuesSunday !== ''||
      bereavementValuesMonday !== '' ||
      bereavementValuesTuesday !== '' ||
      bereavementValuesWednesday !== '' ||
      bereavementValuesThursday !== '' ||
      bereavementValuesFriday !== '' ||
      bereavementValuesSaturday !== '' ||
      bereavementValuesSunday !== ''
    ) {
      setDisableButtons(false);
    }
    if (attachmentList.length) {
      setDisableButtons(false);
    }
  });

  const handleOpenNote = (status, day, proj) => {
    setOpenMonHol(false);
    setOpenTueHol(false);
    setOpenWedHol(false);
    setOpenThuHol(false);
    setOpenFriHol(false);
    setOpenSatHol(false);
    setOpenSunHol(false);

    setOpenMonVac(false);
    setOpenTueVac(false);
    setOpenWedVac(false);
    setOpenThuVac(false);
    setOpenFriVac(false);
    setOpenSatVac(false);
    setOpenSunVac(false);

    setOpenMonSick(false);
    setOpenTueSick(false);
    setOpenWedSick(false);
    setOpenThuSick(false);
    setOpenFriSick(false);
    setOpenSatSick(false);
    setOpenSunSick(false);

    setOpenMonBere(false);
    setOpenTueBere(false);
    setOpenWedBere(false);
    setOpenThuBere(false);
    setOpenFriBere(false);
    setOpenSatBere(false);
    setOpenSunBere(false);

    if (proj !== undefined) {
      setProject(proj);
      setOpenProjectNotes({
        [proj.name]: {
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
        },
      });
    } else {
      setOpenProjectNotes({
        [project.name]: {
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
        },
      });
    }

    if (proj !== undefined) {
      if (status === 'regular') {
        if (day === 'monday') {
          setOpenProjectNotes({
            [proj.name]: {
              monday: true,
              tuesday: false,
              wednesday: false,
              thursday: false,
              friday: false,
              saturday: false,
              sunday: false,
            },
          });
        }
        if (day === 'tuesday') {
          setOpenProjectNotes({
            [proj.name]: {
              monday: false,
              tuesday: true,
              wednesday: false,
              thursday: false,
              friday: false,
              saturday: false,
              sunday: false,
            },
          });
        }
        if (day === 'wednesday') {
          setOpenProjectNotes({
            [proj.name]: {
              monday: false,
              tuesday: false,
              wednesday: true,
              thursday: false,
              friday: false,
              saturday: false,
              sunday: false,
            },
          });
        }
        if (day === 'thursday') {
          setOpenProjectNotes({
            [proj.name]: {
              monday: false,
              tuesday: false,
              wednesday: false,
              thursday: true,
              friday: false,
              saturday: false,
              sunday: false,
            },
          });
        }
        if (day === 'friday') {
          setOpenProjectNotes({
            [proj.name]: {
              monday: false,
              tuesday: false,
              wednesday: false,
              thursday: false,
              friday: true,
              saturday: false,
              sunday: false,
            },
          });
        }
        if (day === 'saturday') {
          setOpenProjectNotes({
            [proj.name]: {
              monday: false,
              tuesday: false,
              wednesday: false,
              thursday: false,
              friday: false,
              saturday: true,
              sunday: false,
            },
          });
        }
        if (day === 'sunday') {
          setOpenProjectNotes({
            [proj.name]: {
              monday: false,
              tuesday: false,
              wednesday: false,
              thursday: false,
              friday: false,
              saturday: false,
              sunday: true,
            },
          });
        }
      }
    } else {
      if (status === 'holiday') {
        if (day === 'monday') {
          setOpenMonHol(true);
        }
        if (day === 'tuesday') {
          setOpenTueHol(true);
        }
        if (day === 'wednesday') {
          setOpenWedHol(true);
        }
        if (day === 'thursday') {
          setOpenThuHol(true);
        }
        if (day === 'friday') {
          setOpenFriHol(true);
        }
        if (day === 'saturday') {
          setOpenSatHol(true);
        }
        if (day === 'sunday') {
          setOpenSunHol(true);
        }
      }

      if (status === 'vacation') {
        if (day === 'monday') {
          setOpenMonVac(true);
        }
        if (day === 'tuesday') {
          setOpenTueVac(true);
        }
        if (day === 'wednesday') {
          setOpenWedVac(true);
        }
        if (day === 'thursday') {
          setOpenThuVac(true);
        }
        if (day === 'friday') {
          setOpenFriVac(true);
        }
        if (day === 'saturday') {
          setOpenSatVac(true);
        }
        if (day === 'sunday') {
          setOpenSunVac(true);
        }
      }

      if (status === 'sick') {
        if (day === 'monday') {
          setOpenMonSick(true);
        }
        if (day === 'tuesday') {
          setOpenTueSick(true);
        }
        if (day === 'wednesday') {
          setOpenWedSick(true);
        }
        if (day === 'thursday') {
          setOpenThuSick(true);
        }
        if (day === 'friday') {
          setOpenFriSick(true);
        }
        if (day === 'saturday') {
          setOpenSatSick(true);
        }
        if (day === 'sunday') {
          setOpenSunSick(true);
        }
      }
      if (status === 'bereavement') {
        if (day === 'monday') {
          setOpenMonBere(true);
        }
        if (day === 'tuesday') {
          setOpenTueBere(true);
        }
        if (day === 'wednesday') {
          setOpenWedBere(true);
        }
        if (day === 'thursday') {
          setOpenThuBere(true);
        }
        if (day === 'friday') {
          setOpenFriBere(true);
        }
        if (day === 'saturday') {
          setOpenSatBere(true);
        }
        if (day === 'sunday') {
          setOpenSunBere(true);
        }
      }
    }
  };

  useEffect(() => {
    if (render) {
      dispatch(
        fetchTimesheet({
          fromDate: `${week.startDate}`,
          toDate: `${week.endDate}`,
          role: user.role,
          userId: user.id,
        })
      );
    }
  }, [render]);

  useEffect(() => {
    if (arrowClick > 0) {
      dispatch(
        fetchTimesheet({
          fromDate: `${week.startDate}`,
          toDate: `${week.endDate}`,
          role: user.role,
          userId: user.id,
        })
      );
    }
  }, [arrowClick]);

  useEffect(() => {
    setProjectValues({
      [defaultProject.name]: {
        monday: '',
        tuesday: '',
        wednesday: '',
        thursday: '',
        friday: '',
        saturday: '',
        sunday: '',
      },
    });
    setProjectNotes({
      [defaultProject.name]: {
        monday: '',
        tuesday: '',
        wednesday: '',
        thursday: '',
        friday: '',
        saturday: '',
        sunday: '',
      },
    });
    setProjectIds({
      [defaultProject.name]: {
        monday: null,
        tuesday: null,
        wednesday: null,
        thursday: null,
        friday: null,
        saturday: null,
        sunday: null,
      },
    });

    setHolidayValuesMonday('');
    setHolidayValuesTuesday('');
    setHolidayValuesWednesday('');
    setHolidayValuesThursday('');
    setHolidayValuesFriday('');
    setHolidayValuesSaturday('');
    setHolidayValuesSunday('');

    setVacationValuesMonday('');
    setVacationValuesTuesday('');
    setVacationValuesWednesday('');
    setVacationValuesThursday('');
    setVacationValuesFriday('');
    setVacationValuesSaturday('');
    setVacationValuesSunday('');

    setBereavementValuesMonday('');
    setBereavementValuesTuesday('');
    setBereavementValuesWednesday('');
    setBereavementValuesThursday('');
    setBereavementValuesFriday('');
    setBereavementValuesSaturday('');
    setBereavementValuesSunday('');

    setSickValuesMonday('');
    setSickValuesTuesday('');
    setSickValuesWednesday('');
    setSickValuesThursday('');
    setSickValuesFriday('');
    setSickValuesSaturday('');
    setSickValuesSunday('');

    setHolidayNotesMonday('');
    setHolidayNotesTuesday('');
    setHolidayNotesWednesday('');
    setHolidayNotesThursday('');
    setHolidayNotesFriday('');
    setHolidayNotesSaturday('');
    setHolidayNotesSunday('');

    setBereavementNotesMonday('');
    setBereavementNotesTuesday('');
    setBereavementNotesWednesday('');
    setBereavementNotesThursday('');
    setBereavementNotesFriday('');
    setBereavementNotesSaturday('');
    setBereavementNotesSunday('');

    setVacationNotesMonday('');
    setVacationNotesTuesday('');
    setVacationNotesWednesday('');
    setVacationNotesThursday('');
    setVacationNotesFriday('');
    setVacationNotesSaturday('');
    setVacationNotesSunday('');

    setSickNotesMonday('');
    setSickNotesTuesday('');
    setSickNotesWednesday('');
    setSickNotesThursday('');
    setSickNotesFriday('');
    setSickNotesSaturday('');
    setSickNotesSunday('');

    setMonHolId(null);
    setTueHolId(null);
    setWedHolId(null);
    setThuHolId(null);
    setFriHolId(null);
    setSatHolId(null);
    setSunHolId(null);

    setMonVacId(null);
    setTueVacId(null);
    setWedVacId(null);
    setThuVacId(null);
    setFriVacId(null);
    setSatVacId(null);
    setSunVacId(null);

    setMonSickId(null);
    setTueSickId(null);
    setWedSickId(null);
    setThuSickId(null);
    setFriSickId(null);
    setSatSickId(null);
    setSunSickId(null);

    setMonBreId(null);
    setTueBreId(null);
    setWedBreId(null);
    setThuBreId(null);
    setFriBreId(null);
    setSatBreId(null);
    setSunBreId(null);

    buildProjectRows();
  }, [timesheet]);

  const buildProjectRows = () => {
    let _comments = '';
    const enumBillable = {
      billable: 'billable',
      nonBillable: 'non-billable',
    };
    let weeklyLastIndex = (timesheet.weekly || []).length - 1;
    let _projectRows = projectRows;
    let _regularStatus = regularStatus;
    let _projectValues = projectValues;
    let _projectNotes = projectNotes;
    let _projectIds = projectIds;
    let _holidayObj = weeksObject();
    let _holidayNoteObj = weeksObject();
    let _holidayIdObj = weeksObject(null);
    let _vacationObj = weeksObject();
    let _vacationNoteObj = weeksObject();
    let _vacationIdObj = weeksObject(null);
    let _sickObj = weeksObject();
    let _sickNoteObj = weeksObject();
    let _sickIdObj = weeksObject(null);
    let _bereObj = weeksObject();
    let _bereNoteObj = weeksObject();
    let _bereIdObj = weeksObject(null);
    let _bereStatus = enumBillable.nonBillable;

    let _holidayStatus = enumBillable.nonBillable;
    let _vacationStatus = enumBillable.nonBillable;
    let _sickStatus = enumBillable.nonBillable;

    if (
      timesheet.weekly &&
      timesheet.weekly[weeklyLastIndex] &&
      timesheet.weekly[weeklyLastIndex].comments
    ) {
      _comments = timesheet.weekly[weeklyLastIndex].comments;
    }

    projects.map(proj => {
      if (proj.isDefault) {
        _projectRows = [];
        _projectRows.push(proj.name);
        _projectValues = {};
        _projectValues[proj.name] = weeksObject('');
        _projectNotes = {};
        _projectNotes[proj.name] = weeksObject('');
        _projectIds = {};
        _projectIds[proj.name] = weeksObject(null);
      }
    });

    timesheet.weekly &&
      timesheet.weekly[weeklyLastIndex] &&
      timesheet.weekly[weeklyLastIndex].days.forEach(day => {
        if (day.projectId && day.task === 'regular') {
          const currentProject = projects.find(proj => {
            return proj.code == day.projectId;
          });
          if (currentProject) {
            const projectName = currentProject.name;
            if (
              !_projectRows.find(item => {
                return item === currentProject.name;
              })
            ) {
              _projectRows.push(currentProject.name);
            }
            if (!_projectValues[projectName]) {
              _projectValues[projectName] = weeksObject('');
            }
            if (!_projectNotes[projectName]) {
              _projectNotes[projectName] = weeksObject('');
            }
            if (!_projectIds[projectName]) {
              _projectIds[projectName] = weeksObject(null);
            }
            _projectValues[projectName][
              moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()
            ] = day.hour;
            _projectNotes[projectName][
              moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()
            ] = day.note;
            _projectIds[projectName][
              moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()
            ] = day.id || null;
          }
        } else {
          switch (day.task) {
            case 'holiday':
              _holidayStatus = day.is_billable
                ? enumBillable.billable
                : enumBillable.nonBillable;
              _holidayObj[moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()] =
                day.hour;
              _holidayNoteObj[
                moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()
              ] = day.note;
              _holidayIdObj[
                moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()
              ] = day.id || null;
              break;
            case 'vacation':
              _vacationStatus = day.is_billable
                ? enumBillable.billable
                : enumBillable.nonBillable;
              _vacationObj[
                moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()
              ] = day.hour;
              _vacationNoteObj[
                moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()
              ] = day.note;
              _vacationIdObj[
                moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()
              ] = day.id || null;
              break;
            case 'sick':
              _sickStatus = day.is_billable
                ? enumBillable.billable
                : enumBillable.nonBillable;
              _sickObj[moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()] =
                day.hour;
              _sickNoteObj[
                moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()
              ] = day.note;
              _sickIdObj[moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()] =
                day.id || null;
              break;
              case 'bereavement':
              _bereStatus = day.is_billable
                ? enumBillable.billable
                : enumBillable.nonBillable;
              _bereObj[moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()] =
                day.hour;
              _bereNoteObj[
                moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()
              ] = day.note;
              _bereIdObj[moment(day.date, DB_DATE_FORMAT).format('dddd').toLowerCase()] =
                day.id || null;
              break;
            default:
              break;
          }
        }
      });

    setProjectRows(_projectRows);
    setRegularStatus(_regularStatus);
    setProjectValues(_projectValues);
    setProjectNotes(_projectNotes);
    setProjectIds(_projectIds);
    setHolidayStatus(_holidayStatus);
    setVacationStatus(_vacationStatus);
    setSickStatus(_sickStatus);
    setBereavementStatus(_bereStatus);

    setHolidayValuesMonday(_holidayObj['monday']);
    setHolidayNotesMonday(_holidayNoteObj['monday']);
    setMonHolId(_holidayIdObj['monday']);
    setVacationValuesMonday(_vacationObj['monday']);
    setVacationNotesMonday(_vacationNoteObj['monday']);
    setMonVacId(_vacationIdObj['monday']);
    setSickValuesMonday(_sickObj['monday']);
    setSickNotesMonday(_sickNoteObj['monday']);
    setMonSickId(_sickIdObj['monday']);
    setBereavementValuesMonday(_bereObj['monday']);
    setBereavementNotesMonday(_bereNoteObj['monday']);
    setMonBreId(_bereIdObj['monday']);

    setHolidayValuesTuesday(_holidayObj['tuesday']);
    setHolidayNotesTuesday(_holidayNoteObj['tuesday']);
    setTueHolId(_holidayIdObj['tuesday']);
    setVacationValuesTuesday(_vacationObj['tuesday']);
    setVacationNotesTuesday(_vacationNoteObj['tuesday']);
    setTueVacId(_vacationIdObj['tuesday']);
    setSickValuesTuesday(_sickObj['tuesday']);
    setSickNotesTuesday(_sickNoteObj['tuesday']);
    setTueSickId(_sickIdObj['tuesday']);
    setBereavementValuesTuesday(_bereObj['tuesday']);
    setBereavementNotesTuesday(_bereNoteObj['tuesday']);
    setTueBreId(_bereIdObj['tuesday']);


    setHolidayValuesWednesday(_holidayObj['wednesday']);
    setHolidayNotesWednesday(_holidayNoteObj['wednesday']);
    setWedHolId(_holidayIdObj['wednesday']);
    setVacationValuesWednesday(_vacationObj['wednesday']);
    setVacationNotesWednesday(_vacationNoteObj['wednesday']);
    setWedVacId(_vacationIdObj['wednesday']);
    setSickValuesWednesday(_sickObj['wednesday']);
    setSickNotesWednesday(_sickNoteObj['wednesday']);
    setWedSickId(_sickIdObj['wednesday']);
    setBereavementValuesWednesday(_bereObj['wednesday']);
    setBereavementNotesWednesday(_bereNoteObj['wednesday']);
    setWedBreId(_bereIdObj['wednesday']);

    setHolidayValuesThursday(_holidayObj['thursday']);
    setHolidayNotesThursday(_holidayNoteObj['thursday']);
    setThuHolId(_holidayIdObj['thursday']);
    setVacationValuesThursday(_vacationObj['thursday']);
    setVacationNotesThursday(_vacationNoteObj['thursday']);
    setThuVacId(_vacationIdObj['thursday']);
    setSickValuesThursday(_sickObj['thursday']);
    setSickNotesThursday(_sickNoteObj['thursday']);
    setThuSickId(_sickIdObj['thursday']);
    setBereavementValuesThursday(_bereObj['thursday']);
    setBereavementNotesThursday(_bereNoteObj['thursday']);
    setThuBreId(_bereIdObj['thursday']);

    setHolidayValuesFriday(_holidayObj['friday']);
    setHolidayNotesFriday(_holidayNoteObj['friday']);
    setFriHolId(_holidayIdObj['friday']);
    setVacationValuesFriday(_vacationObj['friday']);
    setVacationNotesFriday(_vacationNoteObj['friday']);
    setFriVacId(_vacationIdObj['friday']);
    setSickValuesFriday(_sickObj['friday']);
    setSickNotesFriday(_sickNoteObj['friday']);
    setFriSickId(_sickIdObj['friday']);
    setBereavementValuesFriday(_bereObj['friday']);
    setBereavementNotesFriday(_bereNoteObj['friday']);
    setFriBreId(_bereIdObj['friday']);

    setHolidayValuesSaturday(_holidayObj['saturday']);
    setHolidayNotesSaturday(_holidayNoteObj['saturday']);
    setSatHolId(_holidayIdObj['saturday']);
    setVacationValuesSaturday(_vacationObj['saturday']);
    setVacationNotesSaturday(_vacationNoteObj['saturday']);
    setSatVacId(_vacationIdObj['saturday']);
    setSickValuesSaturday(_sickObj['saturday']);
    setSickNotesSaturday(_sickNoteObj['saturday']);
    setSatSickId(_sickIdObj['saturday']);
    setBereavementValuesSaturday(_bereObj['saturday']);
    setBereavementNotesSaturday(_bereNoteObj['saturday']);
    setSatBreId(_bereIdObj['saturday']);

    setHolidayValuesSunday(_holidayObj['sunday']);
    setHolidayNotesSunday(_holidayNoteObj['sunday']);
    setSunHolId(_holidayIdObj['sunday']);
    setVacationValuesSunday(_vacationObj['sunday']);
    setVacationNotesSunday(_vacationNoteObj['sunday']);
    setSunVacId(_vacationIdObj['sunday']);
    setSickValuesSunday(_sickObj['sunday']);
    setSickNotesSunday(_sickNoteObj['sunday']);
    setSunSickId(_sickIdObj['sunday']);
    setBereavementValuesSunday(_bereObj['sunday']);
    setBereavementNotesSunday(_bereNoteObj['sunday']);
    setSunBreId(_bereIdObj['sunday']);
    setComments(_comments);
  };

  const columns = [
    'Task',
    <div className={classes.columns}>
      <div>Sun</div>
      <div>{(weekDays[0] || '').replace('-', '/')}</div>
    </div>,
    <div className={classes.columns}>
      <div>Mon</div>
      <div>{(weekDays[1] || '').replace('-', '/')}</div>
    </div>,
    <div className={classes.columns}>
      <div>Tue</div>
      <div>{(weekDays[2] || '').replace('-', '/')}</div>
    </div>,
    <div className={classes.columns}>
      <div>Wed</div>
      <div>{(weekDays[3] || '').replace('-', '/')}</div>
    </div>,
    <div className={classes.columns}>
      <div>Thu</div>
      <div>{(weekDays[4] || '').replace('-', '/')}</div>
    </div>,
    <div className={classes.columns}>
      <div>Fri</div>
      <div>{(weekDays[5] || '').replace('-', '/')}</div>
    </div>,
    <div className={classes.columns}>
      <div>Sat</div>
      <div>{(weekDays[6] || '').replace('-', '/')}</div>
    </div>,
    'Total',
  ];

  const {
    arrowIcons,
    weekSelectorContent,
    root,
    attachFileButton,
    commentBox,
    gridElRight,
    gridElLeft,
    textFieldCont,
  } = useStyles();

  const handleChange = (e, task, proj) => {
    const { name, value } = e.target;

    if (proj !== undefined) {
      setProjectValues({
        ...projectValues,
        [proj.name]: {
          ...projectValues[proj.name],
          [name]: value,
        },
      });
    }

    if (task === 'holiday') {
      if (name === 'monday') {
        setHolidayValuesMonday(value);
      }
      if (name === 'tuesday') {
        setHolidayValuesTuesday(value);
      }
      if (name === 'wednesday') {
        setHolidayValuesWednesday(value);
      }
      if (name === 'thursday') {
        setHolidayValuesThursday(value);
      }
      if (name === 'friday') {
        setHolidayValuesFriday(value);
      }
      if (name === 'saturday') {
        setHolidayValuesSaturday(value);
      }
      if (name === 'sunday') {
        setHolidayValuesSunday(value);
      }
    }
    if (task === 'vacation') {
      if (name === 'monday') {
        setVacationValuesMonday(value);
      }
      if (name === 'tuesday') {
        setVacationValuesTuesday(value);
      }
      if (name === 'wednesday') {
        setVacationValuesWednesday(value);
      }
      if (name === 'thursday') {
        setVacationValuesThursday(value);
      }
      if (name === 'friday') {
        setVacationValuesFriday(value);
      }
      if (name === 'saturday') {
        setVacationValuesSaturday(value);
      }
      if (name === 'sunday') {
        setVacationValuesSunday(value);
      }
    }
    if (task === 'sick') {
      if (name === 'monday') {
        setSickValuesMonday(value);
      }
      if (name === 'tuesday') {
        setSickValuesTuesday(value);
      }
      if (name === 'wednesday') {
        setSickValuesWednesday(value);
      }
      if (name === 'thursday') {
        setSickValuesThursday(value);
      }
      if (name === 'friday') {
        setSickValuesFriday(value);
      }
      if (name === 'saturday') {
        setSickValuesSaturday(value);
      }
      if (name === 'sunday') {
        setSickValuesSunday(value);
      }
    }
    if (task === 'bereavement') {
      if (name === 'monday') {
        setBereavementValuesMonday(value);
      }
      if (name === 'tuesday') {
        setBereavementValuesTuesday(value);
      }
      if (name === 'wednesday') {
        setBereavementValuesWednesday(value);
      }
      if (name === 'thursday') {
        setBereavementValuesThursday(value);
      }
      if (name === 'friday') {
        setBereavementValuesFriday(value);
      }
      if (name === 'saturday') {
        setBereavementValuesSaturday(value);
      }
      if (name === 'sunday') {
        setBereavementValuesSunday(value);
      }
    }
  };

  const handleDelete = (e, task) => {
    let projectCode = task.name;
    setProject({ name: defaultProject.name, code: defaultProject.code });
    let _projectRows = projectRows;
    let _idx = -1;
    _idx = _projectRows.findIndex(item => item == projectCode);
    if (_idx !== -1) {
      _projectRows.splice(_idx, 1);
      setProjectRows(_projectRows);
    }

    let _projectValues = Object.assign({}, projectValues);
    if (Object.keys(_projectValues).length > 0) {
      delete _projectValues[projectCode];
      setProjectValues(_projectValues);
    }

    let _projectIds = Object.assign({}, projectIds);
    if (Object.keys(_projectIds).length > 0) {
      delete _projectIds[projectCode];
      setProjectIds(_projectIds);
    }

    let _projectNotes = Object.assign({}, projectNotes);
    if (Object.keys(_projectNotes).length > 0) {
      delete _projectNotes[projectCode];
      setProjectNotes(_projectNotes);
    }

    let _openProjectNotes = Object.assign({}, openProjectNotes);
    if (Object.keys(_openProjectNotes).length > 0) {
      delete _openProjectNotes[projectCode];
      setOpenProjectNotes(_openProjectNotes);
    }
  };

  const handleNote = (e, task) => {
    const { name, value } = e.currentTarget;
    if (task === 'regular') {
      setProjectNotes({
        ...projectNotes,
        [project.name]: {
          ...projectNotes[project.name],
          [name]: value,
        },
      });
    }

    if (task === 'holiday') {
      setHolidayNotesMonday(name === 'monday' ? value : holidayNotesMonday);
      setHolidayNotesTuesday(name === 'tuesday' ? value : holidayNotesTuesday);
      setHolidayNotesWednesday(name === 'wednesday' ? value : holidayNotesWednesday);
      setHolidayNotesThursday(name === 'thursday' ? value : holidayNotesThursday);
      setHolidayNotesFriday(name === 'friday' ? value : holidayNotesFriday);
      setHolidayNotesSaturday(name === 'saturday' ? value : holidayNotesSaturday);
      setHolidayNotesSunday(name === 'sunday' ? value : holidayNotesSunday);
    }
    if (task === 'bereavement') {
      setBereavementNotesMonday(name === 'monday' ? value : bereavementNotesMonday);
      setBereavementNotesTuesday(name === 'tuesday' ? value : bereavementNotesTuesday);
      setBereavementNotesWednesday(name === 'wednesday' ? value : bereavementNotesWednesday);
      setBereavementNotesThursday(name === 'thursday' ? value : bereavementNotesThursday);
      setBereavementNotesFriday(name === 'friday' ? value : bereavementNotesFriday);
      setBereavementNotesSaturday(name === 'saturday' ? value : bereavementNotesSaturday);
      setBereavementNotesSunday(name === 'sunday' ? value : bereavementNotesSunday);
    }
    if (task === 'vacation') {
      setVacationNotesMonday(name === 'monday' ? value : vacationNotesMonday);
      setVacationNotesTuesday(name === 'tuesday' ? value : vacationNotesTuesday);
      setVacationNotesWednesday(name === 'wednesday' ? value : vacationNotesWednesday);
      setVacationNotesThursday(name === 'thursday' ? value : vacationNotesThursday);
      setVacationNotesFriday(name === 'friday' ? value : vacationNotesFriday);
      setVacationNotesSaturday(name === 'saturday' ? value : vacationNotesSaturday);
      setVacationNotesSunday(name === 'sunday' ? value : vacationNotesSunday);
    }
    if (task === 'sick') {
      setSickNotesMonday(name === 'monday' ? value : sickNotesMonday);
      setSickNotesTuesday(name === 'tuesday' ? value : sickNotesTuesday);
      setSickNotesWednesday(name === 'wednesday' ? value : sickNotesWednesday);
      setSickNotesThursday(name === 'thursday' ? value : sickNotesThursday);
      setSickNotesFriday(name === 'friday' ? value : sickNotesFriday);
      setSickNotesSaturday(name === 'saturday' ? value : sickNotesSaturday);
      setSickNotesSunday(name === 'sunday' ? value : sickNotesSunday);
    }
  };

  const handleStatus = (e, task) => {
    const { name, value } = e.target;
    if (task === 'regular') {
      setRegularStatus(value);
    }
    if (task === 'holiday') {
      setHolidayStatus(value);
    }
    if (task === 'vacation') {
      setVacationStatus(value);
    }
    if (task === 'sick') {
      setSickStatus(value);
    }
  };

  const calcTotal = (task, proj) => {
    if (task === 'regular' && proj !== undefined) {
      let regularTotal =
        Number(projectValues[proj.name].monday || 0) +
        Number(projectValues[proj.name].tuesday || 0) +
        Number(projectValues[proj.name].wednesday || 0) +
        Number(projectValues[proj.name].thursday || 0) +
        Number(projectValues[proj.name].friday || 0) +
        Number(projectValues[proj.name].saturday || 0) +
        Number(projectValues[proj.name].sunday || 0);
      return regularTotal;
    }

    if (task === 'holiday') {
      let holidayTotal =
        Number(holidayValuesMonday || 0) +
        Number(holidayValuesTuesday || 0) +
        Number(holidayValuesWednesday || 0) +
        Number(holidayValuesThursday || 0) +
        Number(holidayValuesFriday || 0) +
        Number(holidayValuesSaturday || 0) +
        Number(holidayValuesSunday || 0);
      return holidayTotal;
    }
    if (task === 'vacation') {
      let vacationTotal =
        Number(vacationValuesMonday || 0) +
        Number(vacationValuesTuesday || 0) +
        Number(vacationValuesWednesday || 0) +
        Number(vacationValuesThursday || 0) +
        Number(vacationValuesFriday || 0) +
        Number(vacationValuesSaturday || 0) +
        Number(vacationValuesSunday || 0);
      return vacationTotal;
    }
    if (task === 'bereavement') {
      let bereavement =
        Number(bereavementValuesMonday || 0) +
        Number(bereavementValuesTuesday || 0) +
        Number(bereavementValuesWednesday || 0) +
        Number(bereavementValuesThursday || 0) +
        Number(bereavementValuesFriday || 0) +
        Number(bereavementValuesSaturday || 0) +
        Number(bereavementValuesSunday || 0);
      return bereavement;
    }
    
    if (task === 'sick') {
      let sickTotal =
        Number(sickValuesMonday || 0) +
        Number(sickValuesTuesday || 0) +
        Number(sickValuesWednesday || 0) +
        Number(sickValuesThursday || 0) +
        Number(sickValuesFriday || 0) +
        Number(sickValuesSaturday || 0) +
        Number(sickValuesSunday || 0);
      return sickTotal;
    }
  };

  const renderStyledTableCell = () =>
    columns.map(val => <StyledTableCell>{val}</StyledTableCell>);

  const handleComment = e => setComments(e.target.value);

  const handleSave = (mode, status) => {
    let updatedTimesheet = {};
    let eligibaleToSubmit = true;
    let getDaysArray = (start, end) => {
      for (
        var arr = [], dt = new Date(start);
        dt <= new Date(end);
        dt.setDate(dt.getDate() + 1)
      ) {
        arr.push(new Date(dt));
      }
      return arr;
    };

    const daylist = getDaysArray(
      moment(`${week.startDate}`, DB_DATE_FORMAT),
      moment(`${week.endDate}`, DB_DATE_FORMAT)
    );

    const daysArr = daylist.map(day => moment(day).format('MM-DD-YYYY'));

    let getDays = () => {
      let days = [];

      const allProjects = [...projectRows, defaultProject];

      const includedProjects = projects.filter(proj => {
        let isIncluded = false;

        allProjects.forEach(project => {
          if (typeof project === 'object') {
            for (let key in project) {
              if (project[key] === proj.name) {
                isIncluded = true;
              }
            }
          } else {
            if ((project || '') === proj.name) {
              isIncluded = true;
            }
          }
        });

        return isIncluded;
      });
      includedProjects.forEach(proj => {
        if(((attachmentList||[]).length<=0) && proj.approved_attach_req==1 && mode =='Submit'){
          eligibaleToSubmit=false;
          notify('warning', 'Please upload/attach client approved timesheet to submit');
          return false;
        }
        if ((projectValues[proj.name].sunday || 0) > 0) {
          days.push({
            id: projectIds[proj.name].sunday,
            date: daysArr[0],
            is_billable: regularStatus === 'billable' ? true : false,
            task: 'regular',
            note: projectNotes[proj.name].sunday,
            hour: projectValues[proj.name].sunday,
            projectId: proj.code,
          });
        }
        if ((projectValues[proj.name].monday || 0) > 0) {
          days.push({
            id: projectIds[proj.name].monday,
            date: daysArr[1],
            is_billable: regularStatus === 'billable' ? true : false,
            task: 'regular',
            note: projectNotes[proj.name].monday,
            hour: projectValues[proj.name].monday,
            projectId: proj.code,
          });
        }
        if ((projectValues[proj.name].tuesday || 0) > 0) {
          days.push({
            id: projectIds[proj.name].tuesday,
            date: daysArr[2],
            is_billable: regularStatus === 'billable' ? true : false,
            task: 'regular',
            note: projectNotes[proj.name].tuesday,
            hour: projectValues[proj.name].tuesday,
            projectId: proj.code,
          });
        }
        if ((projectValues[proj.name].wednesday || 0) > 0) {
          days.push({
            id: projectIds[proj.name].wednesday,
            date: daysArr[3],
            is_billable: regularStatus === 'billable' ? true : false,
            task: 'regular',
            note: projectNotes[proj.name].wednesday,
            hour: projectValues[proj.name].wednesday,
            projectId: proj.code,
          });
        }
        if ((projectValues[proj.name].thursday || 0) > 0) {
          days.push({
            id: projectIds[proj.name].thursday,
            date: daysArr[4],
            is_billable: regularStatus === 'billable' ? true : false,
            task: 'regular',
            note: projectNotes[proj.name].thursday,
            hour: projectValues[proj.name].thursday,
            projectId: proj.code,
          });
        }
        if ((projectValues[proj.name].friday || 0) > 0) {
          days.push({
            id: projectIds[proj.name].friday,
            date: daysArr[5],
            is_billable: regularStatus === 'billable' ? true : false,
            task: 'regular',
            note: projectNotes[proj.name].friday,
            hour: projectValues[proj.name].friday,
            projectId: proj.code,
          });
        }
        if ((projectValues[proj.name].saturday || 0) > 0) {
          days.push({
            id: projectIds[proj.name].saturday,
            date: daysArr[6],
            is_billable: regularStatus === 'billable' ? true : false,
            task: 'regular',
            note: projectNotes[proj.name].saturday,
            hour: projectValues[proj.name].saturday,
            projectId: proj.code,
          });
        }
      });

      if ((holidayValuesSunday || 0) > 0) {
        days.push({
          id: sunHolId,
          date: daysArr[0],
          is_billable: holidayStatus === 'billable' ? true : false,
          task: 'holiday',
          note: holidayNotesSunday,
          hour: holidayValuesSunday,
        });
      }
      if ((holidayValuesMonday || 0) > 0) {
        days.push({
          id: monHolId,
          date: daysArr[1],
          is_billable: holidayStatus === 'billable' ? true : false,
          task: 'holiday',
          note: holidayNotesMonday,
          hour: holidayValuesMonday,
        });
      }
      if ((holidayValuesTuesday || 0) > 0) {
        days.push({
          id: tueHolId,
          date: daysArr[2],
          is_billable: holidayStatus === 'billable' ? true : false,
          task: 'holiday',
          note: holidayNotesTuesday,
          hour: holidayValuesTuesday,
        });
      }
      if ((holidayValuesWednesday || 0) > 0) {
        days.push({
          id: wedHolId,
          date: daysArr[3],
          is_billable: holidayStatus === 'billable' ? true : false,
          task: 'holiday',
          note: holidayNotesWednesday,
          hour: holidayValuesWednesday,
        });
      }
      if ((holidayValuesThursday || 0) > 0) {
        days.push({
          id: thuHolId,
          date: daysArr[4],
          is_billable: holidayStatus === 'billable' ? true : false,
          task: 'holiday',
          note: holidayNotesThursday,
          hour: holidayValuesThursday,
        });
      }
      if ((holidayValuesFriday || 0) > 0) {
        days.push({
          id: friHolId,
          date: daysArr[5],
          is_billable: holidayStatus === 'billable' ? true : false,
          task: 'holiday',
          note: holidayNotesFriday,
          hour: holidayValuesFriday,
        });
      }
      if ((holidayValuesSaturday || 0) > 0) {
        days.push({
          id: satHolId,
          date: daysArr[6],
          is_billable: holidayStatus === 'billable' ? true : false,
          task: 'holiday',
          note: holidayNotesSaturday,
          hour: holidayValuesSaturday,
        });
      }
      if ((bereavementValuesMonday || 0) > 0) {
        days.push({
          id: monBerId,
          date: daysArr[1],
          is_billable: bereavementStatus === 'billable' ? true : false,
          task: 'bereavement',
          note: bereavementNotesMonday,
          hour: bereavementValuesMonday,
        });
      }
      if ((bereavementValuesTuesday || 0) > 0) {
        days.push({
          id: tueBerId,
          date: daysArr[2],
          is_billable: bereavementStatus === 'billable' ? true : false,
          task: 'bereavement',
          note: bereavementNotesTuesday,
          hour: bereavementValuesTuesday,
        });
      }
      if ((bereavementValuesWednesday || 0) > 0) {
        days.push({
          id: wedBerId,
          date: daysArr[3],
          is_billable: bereavementStatus === 'billable' ? true : false,
          task: 'bereavement',
          note: bereavementNotesWednesday,
          hour: bereavementValuesWednesday,
        });
      }
      if ((bereavementValuesThursday || 0) > 0) {
        days.push({
          id: thuBerId,
          date: daysArr[4],
          is_billable: bereavementStatus === 'billable' ? true : false,
          task: 'bereavement',
          note: bereavementNotesThursday,
          hour: bereavementValuesThursday,
        });
      }
      if ((bereavementValuesFriday || 0) > 0) {
        days.push({
          id: friBerId,
          date: daysArr[5],
          is_billable: bereavementStatus === 'billable' ? true : false,
          task: 'bereavement',
          note: bereavementNotesFriday,
          hour: bereavementValuesFriday,
        });
      }
      if ((bereavementValuesSaturday || 0) > 0) {
        days.push({
          id: satBerId,
          date: daysArr[6],
          is_billable: bereavementStatus === 'billable' ? true : false,
          task: 'bereavement',
          note: bereavementNotesSaturday,
          hour: bereavementValuesSaturday,
        });
      }
      if ((vacationValuesSunday || 0) > 0) {
        days.push({
          id: sunVacId,
          date: daysArr[0],
          is_billable: vacationStatus === 'billable' ? true : false,
          task: 'vacation',
          note: vacationNotesSunday,
          hour: vacationValuesSunday,
        });
      }
      if ((vacationValuesMonday || 0) > 0) {
        days.push({
          id: monVacId,
          date: daysArr[1],
          is_billable: vacationStatus === 'billable' ? true : false,
          task: 'vacation',
          note: vacationNotesMonday,
          hour: vacationValuesMonday,
        });
      }
      if ((vacationValuesTuesday || 0) > 0) {
        days.push({
          id: tueVacId,
          date: daysArr[2],
          is_billable: vacationStatus === 'billable' ? true : false,
          task: 'vacation',
          note: vacationNotesTuesday,
          hour: vacationValuesTuesday,
        });
      }
      if ((vacationValuesWednesday || 0) > 0) {
        days.push({
          id: wedVacId,
          date: daysArr[3],
          is_billable: vacationStatus === 'billable' ? true : false,
          task: 'vacation',
          note: vacationNotesWednesday,
          hour: vacationValuesWednesday,
        });
      }
      if ((vacationValuesThursday || 0) > 0) {
        days.push({
          id: thuVacId,
          date: daysArr[4],
          is_billable: vacationStatus === 'billable' ? true : false,
          task: 'vacation',
          note: vacationNotesThursday,
          hour: vacationValuesThursday,
        });
      }
      if ((vacationValuesFriday || 0) > 0) {
        days.push({
          id: friVacId,
          date: daysArr[5],
          is_billable: vacationStatus === 'billable' ? true : false,
          task: 'vacation',
          note: vacationNotesFriday,
          hour: vacationValuesFriday,
        });
      }
      if ((vacationValuesSaturday || 0) > 0) {
        days.push({
          id: satVacId,
          date: daysArr[6],
          is_billable: vacationStatus === 'billable' ? true : false,
          task: 'vacation',
          note: vacationNotesSaturday,
          hour: vacationValuesSaturday,
        });
      }
      if ((sickValuesSunday || 0) > 0) {
        days.push({
          id: sunSickId,
          date: daysArr[0],
          is_billable: sickStatus === 'billable' ? true : false,
          task: 'sick',
          note: sickNotesSunday,
          hour: sickValuesSunday,
        });
      }
      if ((sickValuesMonday || 0) > 0) {
        days.push({
          id: monSickId,
          date: daysArr[1],
          is_billable: sickStatus === 'billable' ? true : false,
          task: 'sick',
          note: sickNotesMonday,
          hour: sickValuesMonday,
        });
      }
      if ((sickValuesTuesday || 0) > 0) {
        days.push({
          id: tueSickId,
          date: daysArr[2],
          is_billable: sickStatus === 'billable' ? true : false,
          task: 'sick',
          note: sickNotesTuesday,
          hour: sickValuesTuesday,
        });
      }
      if ((sickValuesWednesday || 0) > 0) {
        days.push({
          id: wedSickId,
          date: daysArr[3],
          is_billable: sickStatus === 'billable' ? true : false,
          task: 'sick',
          note: sickNotesWednesday,
          hour: sickValuesWednesday,
        });
      }
      if ((sickValuesThursday || 0) > 0) {
        days.push({
          id: thuSickId,
          date: daysArr[4],
          is_billable: sickStatus === 'billable' ? true : false,
          task: 'sick',
          note: sickNotesThursday,
          hour: sickValuesThursday,
        });
      }
      if ((sickValuesFriday || 0) > 0) {
        days.push({
          id: friSickId,
          date: daysArr[5],
          is_billable: sickStatus === 'billable' ? true : false,
          task: 'sick',
          note: sickNotesFriday,
          hour: sickValuesFriday,
        });
      }
      if ((sickValuesSaturday || 0) > 0) {
        days.push({
          id: satSickId,
          date: daysArr[6],
          is_billable: sickStatus === 'billable' ? true : false,
          task: 'sick',
          note: sickNotesSaturday,
          hour: sickValuesSaturday,
        });
      }
      return days;
    };

    if (timesheet.weekly) {
      updatedTimesheet = {
        fromDate: `${week.startDate}`,
        toDate: `${week.endDate}`,
        role: user.role,
        userId: user.id,
        mode: mode,
        tsData: {
          users: [
            {
              id: user.id,
              firstName: user.firstName,
              middleName: user.middleName,
              lastName: user.lastName,
              emailId: user.emailId,
              mobile: user.mobile,
              role: user.role,
              sick: user.sick,
              vacation: user.vacation,
              bereavement:user.bereavement,
              holiday: user.holiday,
              active: user.active,
              responseMessage: user.responseMessage,
              weekly: [
                {
                  tsId:
                    timesheet.weekly[0] === undefined ? null : timesheet.weekly[0].tsId,
                  userId: user.id,
                  fromDate: `${week.startDate}`,
                  toDate: `${week.endDate}`,
                  comments: comments,
                  status: status,
                  hours: '',
                  days: getDays(),
                },
              ],
            },
          ],
        },
      };
    }
    if(eligibaleToSubmit){
      dispatch(updateTimesheet(updatedTimesheet, mode));
    }
  };

  const removeAttachments = (e, id) => {
    const conformStatus = window.confirm('Are you sure want to delete the file?');

    if (conformStatus) {
      dispatch(removeAttachment(id));

      const filteredAttachments = attachmentList.filter(att => att.id !== id);
      setAttachmentList(filteredAttachments);
    }
  };

  const getFile = e => {
    if (e.target.files.length > 0) {
      const fileSize = e.target.files[0].size / 1024 / 1024;
      if (fileSize > UPLOAD_FILE_SIZE) {
        notify('error', `File size exceeds ${UPLOAD_FILE_SIZE} mb!`);
        e.target.value = '';
        return false;
      }
      const fromDate = `${week.startDate}`;
      const toDate = `${week.endDate}`;
      const file = e.target.files[0];

      e.target.value = '';
      const upload = async () => {
        const response = await dispatch(
          uploadTimeSheetAttachments(file, fromDate, toDate, user.id)
        );

        if (response) {
          setAttachmentList([...attachmentList, response]);
          return true;
        } else {
          notify('error', 'File upload failed.');
          return false;
        }
      };
      upload();
    }
  };

  const projectsList = projects
    .filter(project => !project.isDefault && projectRows.includes(project.name))
    .map(project => {
      return (
        <TimeInputRow
          task={'regular'}
          project={project}
          defaultProject={defaultProject}
          status={regularStatus}
          handleChange={handleChange}
          handleStatus={handleStatus}
          calcTotal={calcTotal}
          disable={disable}
          handleOpenNote={handleOpenNote}
          projectValues={projectValues[project.name]}
          projectNotes={projectNotes[project.name]}
          deleteProject={handleDelete}
        />
      );
    });

  const commentBoxes = () => {
    return (
      <TextField
        id='outlined-multiline-static'
        label='Comments for Admin'
        multiline
        rows='4'
        variant='outlined'
        className={commentBox}
        name='admin'
        value={comments || ''}
        onChange={handleComment}
        disabled={disable}
      />
    );
  };

  const handleTaskChange = proj =>
    setFilteredItems({ ...filteredItems, [proj]: !filteredItems[proj] });

  const projectFilters = projects
    .filter(
      project =>
        projectRows.includes(project.name) || project.name === defaultProject.name
    )
    .map(project => {
      return (
        <FormControlLabel
          value={project.name}
          control={
            <Checkbox
              checked={filteredItems[project.name]}
              onChange={() => handleTaskChange(project.name)}
              value={project.name}
              color='primary'
              inputProps={{
                'aria-label': 'secondary checkbox',
              }}
            />
          }
          label={project.name}
          labelPlacement='start'
        />
      );
    });

  const handlePDF = e => handlePrint();

  const handlePrint = () => {
    let printObj = handleExport();
    let tableArray = [];
    printObj.forEach(item => {
      tableArray.push(
        '<table style="width:100%; border: 1px solid gray; border-collapse: collapse;" border="1">' +
          GenerateTable(item).innerHTML +
          '</table>'
      );
    });
   /*  let pri = document.getElementById('ifmcontentstoprint').contentWindow;
    pri.document.open();*/
    let pageHeader = `<div style="padding-bottom:5px"><img width="120px" src="${logoUrl}" /></div>
    <table width="100%" border="0"><tr><td style="text-align:center"><h5>Timesheet Details</h5></td></tr></table>`;
   /*  pri.document.write(pageHeader + tableArray.map(item => item));
    pri.document.close();
    pri.focus();
    pri.print(); */ 

    let win = window.open('printTimesheet', "_new");
    win.document.open();
    win.document.write([
        '<html>',
        '   <head>',
        '   </head>',
        '   <body onload="window.print()" onafterprint="window.close()">',
        pageHeader + tableArray.map(item => item),
        '   </body>',
        '</html>'
    ].join(''));
    win.document.close();
  };

  const GenerateTable = tableObj => {
    let table = document.createElement('TABLE');
    let columnCount = tableObj.columns;

    let row = table.insertRow(-1);
    for (let i = 0; i < columnCount.length; i++) {
      let headerCell = document.createElement('TH');
      headerCell.style.border = 'border: 1px solid gray;';

      headerCell.style.padding = '2px';
      headerCell.style.textAlign = 'left';
      headerCell.innerHTML = columnCount[i];
      row.appendChild(headerCell);
    }

    for (let i = 0; i < tableObj.data.length; i++) {
      row = table.insertRow(-1);
      for (let j = 0; j < tableObj.data[i].length; j++) {
        let cell = row.insertCell(-1);
        cell.style.border = 'border: 1px solid gray;';

        cell.style.padding = '2px';
        cell.style.textAlign = 'left';
        if(tableObj.data[i][0]==='Status :' && j===1){
          cell.style.color='green';
          cell.style.fontWeight = "900";
          cell.innerHTML = tableObj.data[i][j];
        }
        cell.innerHTML = tableObj.data[i][j];
      }
    }
    return table;
  };

  const handleExport = () => {
    const data = [];
    let selectedProjects = projects.filter(project => {
      return (
        (projectRows.includes(project.name) || project.name === defaultProject.name) &&
        filteredItems[project.name] !== false
      );
    });

    const fromDate = convertToDateString(`${week.startDate}`, DB_DATE_FORMAT);
    const toDate = convertToDateString(`${week.endDate}`, DB_DATE_FORMAT);

    let dateArray = [];
    let cDate = moment(fromDate, DISPLAY_DATE_FORMAT);
    while (cDate <= moment(toDate, DISPLAY_DATE_FORMAT)) {
      const weekDay = cDate.format('dddd').toLowerCase();
      let billableHrs = 0;
      let nonBillableHrs = 0;
      let taskDetails = '';
      switch (cDate.format('dddd')) {
        case 'Sunday':
          if ((filteredItems['Holiday'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (holidayValuesSunday || 0);
            if ((holidayNotesSunday || '').length > 0) {
              taskDetails = taskDetails + ', ' + holidayNotesSunday;
            }
          }
          if ((filteredItems['Sick'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (sickValuesSunday || 0);
            if ((sickNotesSunday || '').length > 0) {
              taskDetails = taskDetails + ', ' + sickNotesSunday;
            }
          }
          if ((filteredItems['Vacation'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (vacationValuesSunday || 0);
            if ((vacationNotesSunday || '').length > 0) {
              taskDetails = taskDetails + ', ' + vacationNotesSunday;
            }
          }
          break;
        case 'Monday':
          if ((filteredItems['Holiday'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (holidayValuesMonday || 0);
            if ((holidayNotesMonday || '').length > 0) {
              taskDetails = taskDetails + ', ' + holidayNotesMonday;
            }
          }
          if ((filteredItems['Sick'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (sickValuesMonday || 0);
            if ((sickNotesMonday || '').length > 0) {
              taskDetails = taskDetails + ', ' + sickNotesMonday;
            }
          }
          if ((filteredItems['Vacation'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (vacationValuesMonday || 0);
            if ((vacationNotesMonday || '').length > 0) {
              taskDetails = taskDetails + ', ' + vacationNotesMonday;
            }
          }
          break;
        case 'Tuesday':
          if ((filteredItems['Holiday'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (holidayValuesTuesday || 0);
            if ((holidayNotesTuesday || '').length > 0) {
              taskDetails = taskDetails + ', ' + holidayNotesTuesday;
            }
          }
          if ((filteredItems['Sick'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (sickValuesTuesday || 0);
            if ((sickNotesTuesday || '').length > 0) {
              taskDetails = taskDetails + ', ' + sickNotesTuesday;
            }
          }
          if ((filteredItems['Vacation'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (vacationValuesTuesday || 0);
            if ((vacationNotesTuesday || '').length > 0) {
              taskDetails = taskDetails + ', ' + vacationNotesTuesday;
            }
          }
          break;
        case 'Wednesday':
          if ((filteredItems['Holiday'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (holidayValuesWednesday || 0);
            if ((holidayNotesWednesday || '').length > 0) {
              taskDetails = taskDetails + ', ' + holidayNotesWednesday;
            }
          }
          if ((filteredItems['Sick'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (sickValuesWednesday || 0);
            if ((sickNotesWednesday || '').length > 0) {
              taskDetails = taskDetails + ', ' + sickNotesWednesday;
            }
          }
          if ((filteredItems['Vacation'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (vacationValuesWednesday || 0);
            if ((vacationNotesWednesday || '').length > 0) {
              taskDetails = taskDetails + ', ' + vacationNotesWednesday;
            }
          }
          break;
        case 'Thursday':
          if ((filteredItems['Holiday'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (holidayValuesThursday || 0);
            if ((holidayNotesThursday || '').length > 0) {
              taskDetails = taskDetails + ', ' + holidayNotesThursday;
            }
          }
          if ((filteredItems['Sick'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (sickValuesThursday || 0);
            if ((sickNotesThursday || '').length > 0) {
              taskDetails = taskDetails + ', ' + sickNotesThursday;
            }
          }
          if ((filteredItems['Vacation'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (vacationValuesThursday || 0);
            if ((vacationNotesThursday || '').length > 0) {
              taskDetails = taskDetails + ', ' + vacationNotesThursday;
            }
          }
          break;
        case 'Friday':
          if ((filteredItems['Holiday'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (holidayValuesFriday || 0);
            if ((holidayNotesFriday || '').length > 0) {
              taskDetails = taskDetails + ', ' + holidayNotesFriday;
            }
          }
          if ((filteredItems['Sick'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (sickValuesFriday || 0);
            if ((sickNotesFriday || '').length > 0) {
              taskDetails = taskDetails + ', ' + sickNotesFriday;
            }
          }
          if ((filteredItems['Vacation'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (vacationValuesFriday || 0);
            if ((vacationNotesFriday || '').length > 0) {
              taskDetails = taskDetails + ', ' + vacationNotesFriday;
            }
          }
          break;
        case 'Saturday':
          if ((filteredItems['Holiday'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (holidayValuesSaturday || 0);
            if ((holidayNotesSaturday || '').length > 0) {
              taskDetails = taskDetails + ', ' + holidayNotesSaturday;
            }
          }
          if ((filteredItems['Sick'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (sickValuesSaturday || 0);
            if ((sickNotesSaturday || '').length > 0) {
              taskDetails = taskDetails + ', ' + sickNotesSaturday;
            }
          }
          if ((filteredItems['Vacation'] || false) === true) {
            nonBillableHrs = nonBillableHrs + (vacationValuesSaturday || 0);
            if ((vacationNotesSaturday || '').length > 0) {
              taskDetails = taskDetails + ', ' + vacationNotesSaturday;
            }
          }
          break;
        default:
          break;
      }
      selectedProjects.forEach(pr => {
        billableHrs = billableHrs + (projectValues[pr.name][weekDay] || 0);
        if ((projectNotes[pr.name][weekDay] || '').length > 0) {
          taskDetails = taskDetails + ', ' + (projectNotes[pr.name][weekDay] || '');
        }
      });
      let res = taskDetails.trim().charAt(0);
      if (res === ',') {
        taskDetails = taskDetails.substr(1, taskDetails.length);
      }
      dateArray.push([
        convertToDateString(cDate),
        (billableHrs || 0) === 0 ? '' : billableHrs,
        (nonBillableHrs || 0) === 0 ? '' : nonBillableHrs,
        taskDetails,
      ]);
      cDate = cDate.add(1, 'days');
    }
    let status='';
      if (timesheet && timesheet.weekly && timesheet.weekly[0]) {
        status=timesheet.weekly[0].status;
      }
    data.push(
      {
        columns: [],
        data: [
          ['Name :', user['firstName'] + ' ' + user['lastName'], ''],
          ['Project :', selectedProjects.map(pro => pro.name).join(', '), ''],
          ['Duration :', fromDate, toDate],
          ['Status :', status,'']
        ],
      },
      {
        columns: ['Date', 'Billable', 'Non-Billable', 'Task Details'],
        data: dateArray,
      }
    );
    return data;
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <h1>Timesheet</h1>
      <Grid container alignItems='center' justify='center'>
        <Grid item xs={12} md={4} className={classes.gridElLeft}>
          <FormControl variant='outlined' className={classes.inputMobile}>
            <Select
              multiple
              displayEmpty
              value={projectRows}
              defaultValue='Add Project'
              onChange={handleProject}
            >
              {projects.map(project => {
                return (
                  <MenuItem
                    name={project.code}
                    value={project.name}
                    onChange={handleProject}
                    disabled={
                      defaultProject.name === project.name ||
                      projectRows.includes(project.name)
                    }
                  >
                    {project.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>        
        <Grid xs={12} md={4} item container justify='center'>
          <Button
            onClick={() => {
              let _weekObj = {};
              _weekObj.startDate = moment(week.startDate, DB_DATE_FORMAT)
                .add(-7, 'day')
                .format(DB_DATE_FORMAT);
              _weekObj.endDate = moment(week.endDate, DB_DATE_FORMAT)
                .add(-7, 'day')
                .format(DB_DATE_FORMAT);
              setWeek(_weekObj);
              setArrowClick(arrowClick + 1);
            }}
          >
            <ArrowBackIosIcon className={arrowIcons} />
          </Button>
          {week && (
            <h2 className={weekSelectorContent}>{`${moment(
              week.startDate,
              DB_DATE_FORMAT
            ).format('MM/DD')} - ${moment(week.endDate, DB_DATE_FORMAT).format(
              'MM/DD'
            )}`}</h2>
          )}
          <Button
            onClick={() => {
              let _weekObj = {};
              _weekObj.startDate = moment(week.startDate, DB_DATE_FORMAT)
                .add(7, 'day')
                .format(DB_DATE_FORMAT);
              _weekObj.endDate = moment(week.endDate, DB_DATE_FORMAT)
                .add(7, 'day')
                .format(DB_DATE_FORMAT);
              setWeek(_weekObj);
              setArrowClick(arrowClick + 1);
            }}
          >
            <ArrowForwardIosIcon className={arrowIcons} />
          </Button>
        </Grid>
        <Grid item xs={12} md={4} className={classes.gridElRight}>
        <Button
            color='secondary'
            style={{ margin: '5px' }}
            variant='contained'
            onClick={handlePDF}
          >
            <PrintIcon />
          </Button>
          <Button
            className={classes.btnMobile}
            variant='contained'
            onClick={() => setOpenFilters(!openFilters)}
          >
            <SvgIcon>
              <path d='M 12 3 L 2 5 L 2 19 L 12 21 L 12 3 z M 14 5 L 14 7 L 16 7 L 16 9 L 14 9 L 14 11 L 16 11 L 16 13 L 14 13 L 14 15 L 16 15 L 16 17 L 14 17 L 14 19 L 21 19 C 21.552 19 22 18.552 22 18 L 22 6 C 22 5.448 21.552 5 21 5 L 14 5 z M 18 7 L 20 7 L 20 9 L 18 9 L 18 7 z M 4.1757812 8.296875 L 5.953125 8.296875 L 6.8769531 10.511719 C 6.9519531 10.692719 7.0084063 10.902625 7.0664062 11.140625 L 7.0917969 11.140625 C 7.1247969 10.997625 7.1919688 10.779141 7.2929688 10.494141 L 8.3222656 8.296875 L 9.9433594 8.296875 L 8.0078125 11.966797 L 10 15.703125 L 8.2714844 15.703125 L 7.1582031 13.289062 C 7.1162031 13.204062 7.0663906 13.032922 7.0253906 12.794922 L 7.0097656 12.794922 C 6.9847656 12.908922 6.934375 13.079594 6.859375 13.308594 L 5.7363281 15.703125 L 4 15.703125 L 6.0605469 11.996094 L 4.1757812 8.296875 z M 18 11 L 20 11 L 20 13 L 18 13 L 18 11 z M 18 15 L 20 15 L 20 17 L 18 17 L 18 15 z' />
            </SvgIcon>
          </Button>
        </Grid>
      </Grid>
      {openFilters && (
        <>
          <ExportExcelUser data={handleExport()} />         
        </>
      )}
      {openFilters && projectFilters}
      {openFilters && (
        <>
          <FormControlLabel
            value='Holiday'
            control={
              <Checkbox
                checked={filteredItems['Holiday']}
                onChange={() => handleTaskChange('Holiday')}
                value='Holiday'
                color='primary'
                inputProps={{
                  'aria-label': 'secondary checkbox',
                }}
              />
            }
            label='Holiday'
            labelPlacement='start'
          />
          <FormControlLabel
            value='Vacation'
            control={
              <Checkbox
                checked={filteredItems['Vacation']}
                onChange={() => handleTaskChange('Vacation')}
                value='Vacation'
                color='primary'
                inputProps={{
                  'aria-label': 'secondary checkbox',
                }}
              />
            }
            label='Vacation'
            labelPlacement='start'
          />
          <FormControlLabel
            value='Sick'
            control={
              <Checkbox
                checked={filteredItems['Sick']}
                onChange={() => handleTaskChange('Sick')}
                value='Sick'
                color='primary'
                inputProps={{
                  'aria-label': 'secondary checkbox',
                }}
              />
            }
            label='Sick'
            labelPlacement='start'
          />
           <FormControlLabel
            value='bereavement'
            control={
              <Checkbox
                checked={filteredItems['bereavement']}
                onChange={() => handleTaskChange('bereavement')}
                value='bereavement'
                color='primary'
                inputProps={{
                  'aria-label': 'secondary checkbox',
                }}
              />
            }
            label='bereavement'
            labelPlacement='start'
          />
        </>
      )}

      <Paper className={root}>
        <Table>
          <TableHead>
            <TableRow>{renderStyledTableCell()}</TableRow>
          </TableHead>
          <TableBody>
            <TimeInputRow
              task={'regular'}
              defaultProject
              projectValues
              test4={projectValues[defaultProject.name]}
              project={defaultProject}
              defaultProject={defaultProject}
              status={regularStatus}
              handleChange={handleChange}
              handleStatus={handleStatus}
              calcTotal={calcTotal}
              disable={disable}
              handleOpenNote={handleOpenNote}
              projectValues={projectValues[defaultProject.name]}
              projectNotes={projectNotes[defaultProject.name]}
              deleteProject={handleDelete}
            />

            {projectsList}

            <TimeInputRow
              task={'holiday'}
              status={holidayStatus}
              handleChange={handleChange}
              handleOpenNote={handleOpenNote}
              handleStatus={handleStatus}
              calcTotal={calcTotal}
              disable={true}
              holidayValuesMonday={holidayValuesMonday}
              holidayValuesTuesday={holidayValuesTuesday}
              holidayValuesWednesday={holidayValuesWednesday}
              holidayValuesThursday={holidayValuesThursday}
              holidayValuesFriday={holidayValuesFriday}
              holidayValuesSaturday={holidayValuesSaturday}
              holidayValuesSunday={holidayValuesSunday}
              holidayNotesMonday={holidayNotesMonday}
              holidayNotesTuesday={holidayNotesTuesday}
              holidayNotesWednesday={holidayNotesWednesday}
              holidayNotesThursday={holidayNotesThursday}
              holidayNotesFriday={holidayNotesFriday}
              holidayNotesSaturday={holidayNotesSaturday}
              holidayNotesSunday={holidayNotesSunday}
              projectValues={projectValues[defaultProject.name]}
              projectNotes={projectNotes[defaultProject.name]}
              deleteProject={handleDelete}
            />
            <TimeInputRow
              task={'vacation'}
              status={vacationStatus}
              handleChange={handleChange}
              handleOpenNote={handleOpenNote}
              handleStatus={handleStatus}
              calcTotal={calcTotal}
              disable={true}
              vacationValuesMonday={vacationValuesMonday}
              vacationValuesTuesday={vacationValuesTuesday}
              vacationValuesWednesday={vacationValuesWednesday}
              vacationValuesThursday={vacationValuesThursday}
              vacationValuesFriday={vacationValuesFriday}
              vacationValuesSaturday={vacationValuesSaturday}
              vacationValuesSunday={vacationValuesSunday}
              vacationNotesMonday={vacationNotesMonday}
              vacationNotesTuesday={vacationNotesTuesday}
              vacationNotesWednesday={vacationNotesWednesday}
              vacationNotesThursday={vacationNotesThursday}
              vacationNotesFriday={vacationNotesFriday}
              vacationNotesSaturday={vacationNotesSaturday}
              vacationNotesSunday={vacationNotesSunday}
              projectValues={projectValues[defaultProject.name]}
              projectNotes={projectNotes[defaultProject.name]}
              deleteProject={handleDelete}
            />
            <TimeInputRow
              task={'sick'}
              status={sickStatus}
              handleChange={handleChange}
              handleOpenNote={handleOpenNote}
              handleStatus={handleStatus}
              calcTotal={calcTotal}
              disable={true}
              sickValuesMonday={sickValuesMonday}
              sickValuesTuesday={sickValuesTuesday}
              sickValuesWednesday={sickValuesWednesday}
              sickValuesThursday={sickValuesThursday}
              sickValuesFriday={sickValuesFriday}
              sickValuesSaturday={sickValuesSaturday}
              sickValuesSunday={sickValuesSunday}
              sickNotesMonday={sickNotesMonday}
              sickNotesTuesday={sickNotesTuesday}
              sickNotesWednesday={sickNotesWednesday}
              sickNotesThursday={sickNotesThursday}
              sickNotesFriday={sickNotesFriday}
              sickNotesSaturday={sickNotesSaturday}
              sickNotesSunday={sickNotesSunday}
              projectValues={projectValues[defaultProject.name]}
              projectNotes={projectNotes[defaultProject.name]}
              deleteProject={handleDelete}
            />
              <TimeInputRow
              task={'bereavement'}
              status={bereavementStatus}
              handleChange={handleChange}
              handleOpenNote={handleOpenNote}
              handleStatus={handleStatus}
              calcTotal={calcTotal}
              disable={true}
              bereavementValuesMonday={bereavementValuesMonday}
              bereavementValuesTuesday={bereavementValuesTuesday}
              bereavementValuesWednesday={bereavementValuesWednesday}
              bereavementValuesThursday={bereavementValuesThursday}
              bereavementValuesFriday={bereavementValuesFriday}
              bereavementValuesSaturday={bereavementValuesSaturday}
              bereavementValuesSunday={bereavementValuesSunday}
              bereavementNotesMonday={bereavementNotesMonday}
              bereavementNotesTuesday={bereavementNotesTuesday}
              bereavementNotesWednesday={bereavementNotesWednesday}
              bereavementNotesThursday={bereavementNotesThursday}
              bereavementNotesFriday={bereavementNotesFriday}
              bereavementNotesSaturday={bereavementNotesSaturday}
              bereavementNotesSunday={bereavementNotesSunday}
              projectValues={projectValues[defaultProject.name]}
              projectNotes={projectNotes[defaultProject.name]}
              deleteProject={handleDelete}
            />
          </TableBody>
        </Table>
        <Grid>
          {openProjectNotes[project.name].monday && (
            <div className={textFieldCont}>
              <div>
                <TextField
                  label={`Monday ${project.name} Notes`}
                  multiline
                  className={classes.textArea}
                  name='monday'
                  value={projectNotes[project.name].monday || ''}
                  onChange={e => handleNote(e, 'regular')}
                  variant='outlined'
                  disabled={disable}
                  style={{ overflow: 'visible' }}
                />
              </div>
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openProjectNotes[project.name].tuesday && (
            <div className={textFieldCont}>
              <TextField
                label={`Tuesday ${project.name} Notes`}
                multiline
                className={classes.textArea}
                name='tuesday'
                value={projectNotes[project.name].tuesday || ''}
                onChange={e => handleNote(e, 'regular')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openProjectNotes[project.name].wednesday && (
            <div className={textFieldCont}>
              <TextField
                label={`Wednesday ${project.name} Notes`}
                multiline
                className={classes.textArea}
                name='wednesday'
                value={projectNotes[project.name].wednesday || ''}
                onChange={e => handleNote(e, 'regular')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openProjectNotes[project.name].thursday && (
            <div className={textFieldCont}>
              <TextField
                label={`Thursday ${project.name} Notes`}
                multiline
                className={classes.textArea}
                name='thursday'
                value={projectNotes[project.name].thursday || ''}
                onChange={e => handleNote(e, 'regular')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openProjectNotes[project.name].friday && (
            <div className={textFieldCont}>
              <TextField
                label={`Friday ${project.name} Notes`}
                multiline
                className={classes.textArea}
                name='friday'
                value={projectNotes[project.name].friday || ''}
                onChange={e => handleNote(e, 'regular')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openProjectNotes[project.name].saturday && (
            <div className={textFieldCont}>
              <TextField
                label={`Saturday ${project.name} Notes`}
                multiline
                className={classes.textArea}
                name='saturday'
                value={projectNotes[project.name].saturday || ''}
                onChange={e => handleNote(e, 'regular')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openProjectNotes[project.name].sunday && (
            <div className={textFieldCont}>
              <TextField
                label={`Sunday ${project.name} Notes`}
                multiline
                className={classes.textArea}
                name='sunday'
                value={projectNotes[project.name].sunday || ''}
                onChange={e => handleNote(e, 'regular', project)}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openMonHol && (
            <div className={textFieldCont}>
              <TextField
                label='Monday Holiday Notes'
                multiline
                className={classes.textArea}
                name='monday'
                value={holidayNotesMonday}
                onChange={e => handleNote(e, 'holiday')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openTueHol && (
            <div className={textFieldCont}>
              <TextField
                label='Tuesday Holiday Notes'
                multiline
                className={classes.textArea}
                name='tuesday'
                value={holidayNotesTuesday}
                onChange={e => handleNote(e, 'holiday')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openWedHol && (
            <div className={textFieldCont}>
              <TextField
                label='Wednesday Holiday Notes'
                multiline
                className={classes.textArea}
                name='wednesday'
                value={holidayNotesWednesday}
                onChange={e => handleNote(e, 'holiday')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openThuHol && (
            <div className={textFieldCont}>
              <TextField
                label='Thursday Holiday Notes'
                multiline
                className={classes.textArea}
                name='thursday'
                value={holidayNotesThursday}
                onChange={e => handleNote(e, 'holiday')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openFriHol && (
            <div className={textFieldCont}>
              <TextField
                label='Friday Holiday Notes'
                multiline
                className={classes.textArea}
                name='friday'
                value={holidayNotesFriday}
                onChange={e => handleNote(e, 'holiday')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openSatHol && (
            <div className={textFieldCont}>
              <TextField
                label='Saturday Holiday Notes'
                multiline
                className={classes.textArea}
                name='saturday'
                value={holidayNotesSaturday}
                onChange={e => handleNote(e, 'holiday')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openSunHol && (
            <div className={textFieldCont}>
              <TextField
                label='Sunday Holiday Notes'
                multiline
                className={classes.textArea}
                name='sunday'
                value={holidayNotesSunday}
                onChange={e => handleNote(e, 'holiday')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openMonVac && (
            <div className={textFieldCont}>
              <TextField
                label='Monday Vacation Notes'
                multiline
                className={classes.textArea}
                name='monday'
                value={vacationNotesMonday}
                onChange={e => handleNote(e, 'vacation')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openTueVac && (
            <div className={textFieldCont}>
              <TextField
                label='Tuesday Vacation Notes'
                multiline
                className={classes.textArea}
                name='tuesday'
                value={vacationNotesTuesday}
                onChange={e => handleNote(e, 'vacation')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openWedVac && (
            <div className={textFieldCont}>
              <TextField
                label='Wednesday Vacation Notes'
                multiline
                className={classes.textArea}
                name='wednesday'
                value={vacationNotesWednesday}
                onChange={e => handleNote(e, 'vacation')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openThuVac && (
            <div className={textFieldCont}>
              <TextField
                label='Thursday Vacation Notes'
                multiline
                className={classes.textArea}
                name='thursday'
                value={vacationNotesThursday}
                onChange={e => handleNote(e, 'vacation')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openFriVac && (
            <div className={textFieldCont}>
              <TextField
                label='Friday Vacation Notes'
                multiline
                className={classes.textArea}
                name='friday'
                value={vacationNotesFriday}
                onChange={e => handleNote(e, 'vacation')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openSatVac && (
            <div className={textFieldCont}>
              <TextField
                label='Saturday Vacation Notes'
                multiline
                className={classes.textArea}
                name='saturday'
                value={vacationNotesSaturday}
                onChange={e => handleNote(e, 'vacation')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openSunVac && (
            <div className={textFieldCont}>
              <TextField
                label='Sunday Vacation Notes'
                multiline
                className={classes.textArea}
                name='sunday'
                value={vacationNotesSunday}
                onChange={e => handleNote(e, 'vacation')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openMonSick && (
            <div className={textFieldCont}>
              <TextField
                label='Monday Sick Notes'
                multiline
                className={classes.textArea}
                name='monday'
                value={sickNotesMonday}
                onChange={e => handleNote(e, 'sick')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openTueSick && (
            <div className={textFieldCont}>
              <TextField
                label='Tuesday Sick Notes'
                multiline
                className={classes.textArea}
                name='tuesday'
                value={sickNotesTuesday}
                onChange={e => handleNote(e, 'sick')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openWedSick && (
            <div className={textFieldCont}>
              <TextField
                label='Wednesday Sick Notes'
                multiline
                className={classes.textArea}
                name='wednesday'
                value={sickNotesWednesday}
                onChange={e => handleNote(e, 'sick')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openThuSick && (
            <div className={textFieldCont}>
              <TextField
                label='Thursday Sick Notes'
                multiline
                className={classes.textArea}
                name='thursday'
                value={sickNotesThursday}
                onChange={e => handleNote(e, 'sick')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openFriSick && (
            <div className={textFieldCont}>
              <TextField
                label='Friday Sick Notes'
                multiline
                className={classes.textArea}
                name='friday'
                value={sickNotesFriday}
                onChange={e => handleNote(e, 'sick')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openSatSick && (
            <div className={textFieldCont}>
              <TextField
                label='Saturday Sick Notes'
                multiline
                className={classes.textArea}
                name='saturday'
                value={sickNotesSaturday}
                onChange={e => handleNote(e, 'sick')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openSunSick && (
            <div className={textFieldCont}>
              <TextField
                label='Sunday Sick Notes'
                multiline
                className={classes.textArea}
                name='sunday'
                value={sickNotesSunday}
                onChange={e => handleNote(e, 'sick')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
           {openMonBere && (
            <div className={textFieldCont}>
              <TextField
                label='Monday bereavement Notes'
                multiline
                className={classes.textArea}
                name='monday'
                value={bereavementNotesMonday}
                onChange={e => handleNote(e, 'bereavement')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openTueBere && (
            <div className={textFieldCont}>
              <TextField
                label='Tuesday Bereavement Notes'
                multiline
                className={classes.textArea}
                name='tuesday'
                value={bereavementNotesTuesday}
                onChange={e => handleNote(e, 'bereavement')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openWedBere && (
            <div className={textFieldCont}>
              <TextField
                label='Wednesday Bereavement Notes'
                multiline
                className={classes.textArea}
                name='wednesday'
                value={bereavementNotesWednesday}
                onChange={e => handleNote(e, 'bereavement')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openThuBere && (
            <div className={textFieldCont}>
              <TextField
                label='Thursday Bereavement Notes'
                multiline
                className={classes.textArea}
                name='thursday'
                value={bereavementNotesThursday}
                onChange={e => handleNote(e, 'bereavement')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openFriBere && (
            <div className={textFieldCont}>
              <TextField
                label='Friday Bereavement Notes'
                multiline
                className={classes.textArea}
                name='friday'
                value={bereavementNotesFriday}
                onChange={e => handleNote(e, 'bereavement')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openSatBere && (
            <div className={textFieldCont}>
              <TextField
                label='Saturday Bereavement Notes'
                multiline
                className={classes.textArea}
                name='saturday'
                value={bereavementNotesSaturday}
                onChange={e => handleNote(e, 'bereavement')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
          {openSunSick && (
            <div className={textFieldCont}>
              <TextField
                label='Sunday Sick Notes'
                multiline
                className={classes.textArea}
                name='sunday'
                value={sickNotesSunday}
                onChange={e => handleNote(e, 'sick')}
                variant='outlined'
                disabled={disable}
                style={{ overflow: 'visible' }}
              />
              <div>
                <Button
                  variant='contained'
                  color='secondary'
                  className={classes.rowButton}
                  onClick={handleOpenNote}
                >
                  Close
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.rowButton}
                  onClick={() => handleSave('Save', 'SUBMIT_PENDING')}
                  disabled={disable}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
        </Grid>
        <Grid container justify='space-between' alignItems='flex-end'>
          <Grid item xs={12}>
            {attachmentList &&
              attachmentList.map(file => (
                <Chip
                  variant='outlined'
                  size='small'
                  color='primary'
                  clickable
                  disabled={disable}
                  label={
                    file.attachmentUrl &&
                    file.fileName && (
                      <a
                        href={`${file.attachmentUrl}`}
                        rel='noopener noreferrer'
                        target='_blank'
                      >
                        {file.fileName}
                      </a>
                    )
                  }
                  onDelete={e => {
                    removeAttachments(e, file.id);
                  }}
                />
              ))}
          </Grid>
        </Grid>
        {commentBoxes()}
        <Divider light={true} />
        <Grid container alignItems='flex-end'>
          <Grid item xs={12} md={6} className={gridElLeft}>
            <Button
              variant='contained'
              component='label'
              className={attachFileButton}
              onChange={getFile}
              disabled={disable}
            >
              Upload File
              <input type='file' id='fileAttachment' style={{ display: 'none' }} />
            </Button>
          </Grid>
          <Grid item xs={12} md={6} className={gridElRight}>
            <Button
              // disabled={disable || disableButtons}
              className={attachFileButton}
              variant='contained'
              onClick={() => handleChatOpen()}
            >
              Chat
            </Button>
            <Button
              disabled={disable || disableButtons}
              className={attachFileButton}
              variant='contained'
              onClick={()=>{
                
                  handleSave('Save', 'SUBMIT_PENDING')
                
              }}
            >
              Save
            </Button>
            <Button
              className={attachFileButton}
              disabled={disable || disableButtons}
              variant='contained'
              onClick={()=>{
                  handleSave('Submit', 'APPROVAL_PENDING')
               
              }}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Paper>
      <iframe
        title='timesheet-print'
        id='ifmcontentstoprint'
        style={{
          height: '0px',
          width: '0px',
          position: 'absolute',
          fontSize: '7pt',
        }}
        media='print'
      ></iframe>
      <Dialog
        open={chatOpen}
        onClose={handleChatClose}
        aria-labelledby='form-dialog-title'
        fullWidth={true}
        maxWidth={'md'}
      >
        <DialogTitle id='max-width-dialog-title' className={classes.dialogTitleContainer}>
          <Typography variant='h5' className={classes.dialogTitle}>
            Chat
          </Typography>
        </DialogTitle>
        <DialogContent style={{ padding: 0 }}>
          <Paper className={classes.modalTableRoot}>
            <TableContainer className={classes.modalTableContainer}>
              <Table stickyHeader>
                <Divider />
                <TableBody alignItems='center'>
                  <iframe
                    src={chatSrc}
                    style={{ width: '100%', minHeight: '70vh', border: 'none' }}
                  ></iframe>
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={handleChatClose} className={classes.negativeBtn}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Timesheet;
